














import { Component, Prop, Vue } from "vue-property-decorator";
import {
  GridColumnTypes,
  GridColumn,
  GridAction,
  GridActionEvent
} from "@/models/grids/column";
import { FeedbackDto, LanguageDto} from "@/server/app.dtos";
import ConfigsService from "@/services/api/configs.service";
import { Getter } from "vuex-class";
import { FeedbackTypesService } from "@/services/api/feedback.types.service";

@Component
export default class FeedbackQuestionGroupPage extends Vue {
  @Prop() feedback!: FeedbackDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  apiService: ConfigsService = new ConfigsService();
  feedbackTypesService: FeedbackTypesService = new FeedbackTypesService();
  columns: GridColumn[] = [
    {
      text: "Título",
      value: "title",
      type: GridColumnTypes.Text,
      editable: true,
      editableClass: "col-12",
      editableRules: [this.$rules.minLenght(3)]
    },
    {
      text: "Enviar para Estatisticas",
      value: "sendToStatistics",
      type: GridColumnTypes.Boolean,
      editable: true,
      editableClass: "col-12",
    },
    {
      text: "Ponderação",
      value: "reflection",
      type: GridColumnTypes.Interger,
      editable: true,
      editableClass: "col-12",
    }
  ];
  actions: GridAction[] = [
    {
      title: "Opções",
      icon: "las la-ellipsis-v",
      visible: () => false
    }
  ];
  endpoint: string = "";
  primary: string = "idFeedbackQuestionGroup";
  manageGroupsDialog: boolean = false;
  isValid: boolean = false;
  isLoading: boolean = false;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleAction(data: GridActionEvent) {
    this.manageGroupsDialog = true;
  }
}
